import React, { Component } from 'react';

export default class ErrorBox extends Component {

  containerStyle() {
    const result = {
      position: this.props.position || 'relative',
      zIndex: 2000
    };
    if (result.position === 'fixed') {
      result.top = '30px';
      result.left = '50%';
      result.minWidth = '800px';

    }
    return result;
  }

  boxStyle() {
    const result = {
      position: 'relative'
    };
    if ((this.props.position || '') === 'fixed') {
      result.left = '-50%';
    }
    return result;
  }

  render() {
    return <div className="row justify-content-center" style={this.containerStyle()}>
      <div className="col-12 col-md-6" style={this.boxStyle()}>
        <div style={{
               position: 'relative',
               color: 'rgb(255, 255, 255)',
               backgroundColor: 'rgb(180, 0, 0)',
               border: '1px solid rgb(120, 0, 0)',
               borderRadius: '4px',
               textAlign: 'center',
               paddingTop: '10px', paddingBottom: '10px'
           }}>
          {this.props.onClose &&
          <span className="material-icons"
                style={{ fontSize: '16px', position: 'absolute', top: '7px', right: '7px', cursor: 'pointer' }}
                onClick={() => this.props.onClose()}>
            close
          </span>
          }
          {this.props.text || ''}
        </div>
      </div>
    </div>
  }

}
